(() => {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const randomBetween = (min, max) => Math.random() * (max - min) + min;

  const makeGlow = (radius, color) => {
    const canvas = document.createElement("canvas");
    const size = radius * 2;
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext("2d");
    const gradient = ctx.createRadialGradient(radius, radius, 0, radius, radius, radius);
    gradient.addColorStop(0, color.replace("ALPHA", "1"));
    gradient.addColorStop(0.42, color.replace("ALPHA", "0.28"));
    gradient.addColorStop(1, color.replace("ALPHA", "0"));
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, size, size);

    return canvas;
  };

  document.querySelectorAll("[data-celestials-starlight]").forEach((root) => {
    if (root.dataset.starlightInit === "true") return;
    root.dataset.starlightInit = "true";

    const canvas = root.querySelector("canvas");
    const ctx = canvas.getContext("2d");
    const glowGold = makeGlow(64, "rgba(238,214,178,ALPHA)");
    const glowWarm = makeGlow(64, "rgba(255,238,196,ALPHA)");
    const glowViolet = makeGlow(64, "rgba(140,128,190,ALPHA)");
    let width = 0;
    let height = 0;
    let pixelRatio = 1;
    let background = null;
    let stars = [];
    let userStars = [];
    let bursts = [];
    let dust = [];
    let meteors = [];
    let nebulae = [];
    let rafId = null;
    let time = 0;
    let lastTime = 0;
    let nextMeteor = 4;
    const pointer = { x: -9999, y: -9999, sx: -9999, sy: -9999, active: false };

    const resize = () => {
      const rect = root.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      width = rect.width;
      height = rect.height;
      pixelRatio = Math.min(window.devicePixelRatio || 1, 1.75);
      canvas.width = Math.round(width * pixelRatio);
      canvas.height = Math.round(height * pixelRatio);
      ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
      background = ctx.createLinearGradient(0, 0, 0, height);
      background.addColorStop(0, "#29283d");
      background.addColorStop(0.55, "#353449");
      background.addColorStop(1, "#3d3a55");
    };

    const seed = () => {
      stars = [];
      const total = Math.round(Math.min(130, Math.max(70, width / 11)));
      for (let i = 0; i < total; i += 1) {
        stars.push({
          x: randomBetween(0, width),
          y: randomBetween(0, height) * randomBetween(0.48, 1),
          r: randomBetween(0.45, 1.7),
          phase: randomBetween(0, Math.PI * 2),
          speed: randomBetween(0.35, 1.3),
          warm: Math.random() < 0.58
        });
      }

      nebulae = [];
      for (let i = 0; i < 4; i += 1) {
        nebulae.push({
          x: randomBetween(0.08, 0.92),
          y: randomBetween(0.1, 0.72),
          r: randomBetween(0.18, 0.34),
          phase: randomBetween(0, Math.PI * 2),
          speed: randomBetween(0.045, 0.1),
          violet: i % 2 === 0
        });
      }
    };

    const localPoint = (event) => {
      const rect = canvas.getBoundingClientRect();
      return { x: event.clientX - rect.left, y: event.clientY - rect.top };
    };

    const birthStar = (x, y) => {
      if (userStars.length >= 26) userStars.shift();
      userStars.push({ x, y, born: time, phase: randomBetween(0, Math.PI * 2) });
      bursts.push({ x, y, born: time });

      for (let i = 0; i < 10; i += 1) {
        const angle = randomBetween(0, Math.PI * 2);
        const velocity = randomBetween(12, 38);
        dust.push({
          x,
          y,
          vx: Math.cos(angle) * velocity,
          vy: Math.sin(angle) * velocity,
          born: time,
          life: randomBetween(0.65, 1.15)
        });
      }
    };

    const drawScene = (delta) => {
      ctx.fillStyle = background;
      ctx.fillRect(0, 0, width, height);

      nebulae.forEach((nebula) => {
        const x = nebula.x * width + Math.sin(time * nebula.speed + nebula.phase) * 18;
        const y = nebula.y * height + Math.cos(time * nebula.speed * 0.8 + nebula.phase) * 10;
        const radius = nebula.r * width;
        ctx.globalAlpha = 0.1 + 0.04 * Math.sin(time * 0.2 + nebula.phase);
        ctx.drawImage(nebula.violet ? glowViolet : glowGold, x - radius, y - radius, radius * 2, radius * 2);
      });
      ctx.globalAlpha = 1;

      if (pointer.active) {
        pointer.sx += (pointer.x - pointer.sx) * 0.12;
        pointer.sy += (pointer.y - pointer.sy) * 0.12;
        ctx.globalAlpha = 0.15;
        ctx.drawImage(glowWarm, pointer.sx - 105, pointer.sy - 105, 210, 210);
        ctx.globalAlpha = 1;
      }

      const awakeStars = [];
      const awakeRadius = 145;
      stars.forEach((star) => {
        let wake = 0;
        if (pointer.active) {
          const dx = star.x - pointer.sx;
          const dy = star.y - pointer.sy;
          const distance = Math.sqrt(dx * dx + dy * dy);
          wake = distance < awakeRadius ? 1 - distance / awakeRadius : 0;
        }

        if (wake > 0) awakeStars.push({ star, wake });
        const twinkle = 0.42 + 0.32 * Math.sin(time * star.speed + star.phase);
        const alpha = Math.min(1, twinkle + wake * 0.85);
        const radius = star.r + wake * 1.45;
        ctx.globalAlpha = alpha;
        ctx.fillStyle = star.warm ? "#f3e6cb" : "#dcd8ee";
        ctx.beginPath();
        ctx.arc(star.x, star.y, radius, 0, Math.PI * 2);
        ctx.fill();

        if (wake > 0.28) {
          ctx.globalAlpha = wake * 0.45;
          ctx.drawImage(glowWarm, star.x - 13, star.y - 13, 26, 26);
        }
      });
      ctx.globalAlpha = 1;

      if (awakeStars.length > 1) {
        ctx.lineWidth = 0.7;
        for (let i = 0; i < awakeStars.length; i += 1) {
          for (let j = i + 1; j < awakeStars.length; j += 1) {
            const a = awakeStars[i];
            const b = awakeStars[j];
            const dx = a.star.x - b.star.x;
            const dy = a.star.y - b.star.y;
            const distance = Math.sqrt(dx * dx + dy * dy);
            if (distance < 108) {
              ctx.globalAlpha = (1 - distance / 108) * Math.min(a.wake, b.wake) * 0.62;
              ctx.strokeStyle = "#e8ceb0";
              ctx.beginPath();
              ctx.moveTo(a.star.x, a.star.y);
              ctx.lineTo(b.star.x, b.star.y);
              ctx.stroke();
            }
          }
        }
        ctx.globalAlpha = 1;
      }

      userStars.forEach((star) => {
        const age = time - star.born;
        const grow = Math.min(1, age / 1.15);
        const pulse = 0.74 + 0.26 * Math.sin(time * 1.35 + star.phase);
        ctx.globalAlpha = grow * pulse;
        ctx.drawImage(glowGold, star.x - 21, star.y - 21, 42, 42);
        ctx.fillStyle = "#fbeed9";
        ctx.beginPath();
        ctx.arc(star.x, star.y, 2.1 * grow, 0, Math.PI * 2);
        ctx.fill();
        ctx.strokeStyle = "rgba(251,238,217,.78)";
        ctx.lineWidth = 0.8;
        const line = 8.5 * grow * pulse;
        ctx.beginPath();
        ctx.moveTo(star.x - line, star.y);
        ctx.lineTo(star.x + line, star.y);
        ctx.moveTo(star.x, star.y - line);
        ctx.lineTo(star.x, star.y + line);
        ctx.stroke();
      });
      ctx.globalAlpha = 1;

      for (let i = bursts.length - 1; i >= 0; i -= 1) {
        const burst = bursts[i];
        const age = (time - burst.born) / 1.05;
        if (age >= 1) {
          bursts.splice(i, 1);
          continue;
        }
        ctx.globalAlpha = (1 - age) * 0.55;
        ctx.strokeStyle = "#e8ceb0";
        ctx.lineWidth = 1.1 * (1 - age);
        ctx.beginPath();
        ctx.arc(burst.x, burst.y, 6 + age * 42, 0, Math.PI * 2);
        ctx.stroke();
      }

      for (let i = dust.length - 1; i >= 0; i -= 1) {
        const particle = dust[i];
        const age = (time - particle.born) / particle.life;
        if (age >= 1) {
          dust.splice(i, 1);
          continue;
        }
        particle.x += particle.vx * delta;
        particle.y += particle.vy * delta;
        particle.vx *= 0.985;
        particle.vy *= 0.985;
        ctx.globalAlpha = (1 - age) * 0.76;
        ctx.fillStyle = "#e8ceb0";
        ctx.beginPath();
        ctx.arc(particle.x, particle.y, 1, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.globalAlpha = 1;

      nextMeteor -= delta;
      if (nextMeteor <= 0 && meteors.length < 2) {
        meteors.push({
          x: randomBetween(0.1, 0.68) * width,
          y: randomBetween(0, 0.28) * height,
          vx: randomBetween(240, 390),
          vy: randomBetween(80, 145),
          life: 0
        });
        nextMeteor = randomBetween(6, 14);
      }

      for (let i = meteors.length - 1; i >= 0; i -= 1) {
        const meteor = meteors[i];
        meteor.life += delta;
        meteor.x += meteor.vx * delta;
        meteor.y += meteor.vy * delta;
        const fade = Math.min(1, meteor.life * 3) * Math.max(0, 1 - meteor.life / 1.35);
        if (fade <= 0 || meteor.x > width + 80) {
          meteors.splice(i, 1);
          continue;
        }
        const tail = 66;
        const gradient = ctx.createLinearGradient(
          meteor.x,
          meteor.y,
          meteor.x - tail,
          meteor.y - tail * (meteor.vy / meteor.vx)
        );
        gradient.addColorStop(0, `rgba(251,238,217,${0.9 * fade})`);
        gradient.addColorStop(1, "rgba(251,238,217,0)");
        ctx.strokeStyle = gradient;
        ctx.lineWidth = 1.35;
        ctx.beginPath();
        ctx.moveTo(meteor.x, meteor.y);
        ctx.lineTo(meteor.x - tail, meteor.y - tail * (meteor.vy / meteor.vx));
        ctx.stroke();
      }
    };

    const loop = (timestamp) => {
      const delta = Math.min(0.05, (timestamp - lastTime) / 1000 || 0.016);
      lastTime = timestamp;
      time += delta;
      drawScene(delta);
      rafId = requestAnimationFrame(loop);
    };

    const start = () => {
      if (rafId !== null || reduceMotion) return;
      lastTime = performance.now();
      rafId = requestAnimationFrame(loop);
    };

    const stop = () => {
      if (rafId === null) return;
      cancelAnimationFrame(rafId);
      rafId = null;
    };

    root.addEventListener("pointermove", (event) => {
      const point = localPoint(event);
      pointer.x = point.x;
      pointer.y = point.y;
      if (!pointer.active) {
        pointer.sx = point.x;
        pointer.sy = point.y;
        pointer.active = true;
      }
    });

    root.addEventListener("pointerleave", () => {
      pointer.active = false;
    });

    root.addEventListener("pointerdown", (event) => {
      const point = localPoint(event);
      birthStar(point.x, point.y);
      if (reduceMotion) drawScene(0.016);
    });

    resize();
    seed();
    drawScene(0.016);

    if ("ResizeObserver" in window) {
      new ResizeObserver(() => {
        resize();
        seed();
        drawScene(0.016);
      }).observe(root);
    } else {
      window.addEventListener("resize", () => {
        resize();
        seed();
        drawScene(0.016);
      });
    }

    if (reduceMotion) return;
    if (!("IntersectionObserver" in window)) {
      start();
      return;
    }

    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) start();
        else stop();
      });
    }, { threshold: 0 }).observe(root);
  });
})();
